import { useEffect } from "react";

const Card = () => {
  useEffect(() => {
    const cards = document.querySelectorAll(".card");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.remove("opacity-0"); // Fade in
            entry.target.classList.remove(
              "-translate-x-full",
              "translate-x-full",
              "translate-y-full"
            ); // Reset translate
            entry.target.classList.add("translate-x-0", "translate-y-0"); // Move to original position
          }
        });
      },
      { threshold: 0.1 } // Trigger when 10% of the card is visible
    );

    cards.forEach((card) => observer.observe(card));
    return () => observer.disconnect(); // Cleanup on unmount
  }, []);

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      {/* Card 1: From Left */}
      <div
        className="card bg-gray-50 p-6 rounded-lg shadow-sm hover:shadow-md transition-all duration-700 ease-in-out opacity-0 -translate-x-full"
      >
        <h3 className="text-xl font-semibold text-gray-900 mb-4">Vision</h3>
        <p className="text-gray-600 leading-relaxed">
          To achieve global recognition by delivering value-added, traceable
          agricultural products, modernizing Ethiopia's sector through
          strategic partnerships and technology.
        </p>
      </div>

      {/* Card 2: From Right */}
      <div
        className="card bg-gray-50 p-6 rounded-lg shadow-sm hover:shadow-md transition-all duration-700 ease-in-out opacity-0 translate-x-full"
      >
        <h3 className="text-xl font-semibold text-gray-900 mb-4">Mission</h3>
        <p className="text-gray-600 leading-relaxed">
          Our mission is to build a vertically integrated agricultural
          enterprise that delivers high-quality, traceable agricultural
          products to global markets.
        </p>
      </div>

      {/* Card 3: From Bottom, Below Card 1 and Card 2 */}
      <div
        className="card md:col-span-2 bg-gray-50 p-6 rounded-lg shadow-sm hover:shadow-md transition-all duration-700 ease-in-out opacity-0 translate-y-full"
      >
        <h3 className="text-xl font-semibold text-gray-900 mb-4">
          Future Outlook
        </h3>
        <p className="text-gray-600 leading-relaxed text-lg">
          Palnet Industrial Trading PLC is strategically positioned for
          significant growth within the international agricultural market and
          the Ethiopian agricultural sector. We aim to expand our product
          portfolio, strengthen our global network of partners, and continue
          to invest in sustainable and innovative agricultural practices.
        </p>
      </div>
    </div>
  );
};

export default Card;